import Vue from 'vue'
import quotationRequisition from '@/transformers/purchase/quotationRequisition'
import moment from "moment";

/**
 * @author Mariela Temozihui Tlahuel <mariela.temozihui@jbge.com.mx>
 *
 * Search Quatation by folio
 */

function paramsTransformer({ warehouse, search, status, dateFrom, dateTo }) {
  return {
    text: !!search ? search : undefined,
    iwarehouse: warehouse,
    status: !!status ? status : undefined,
    from: !!dateFrom ?  moment(dateFrom).format('YYYY/MM/DD') : undefined ,
    to: !!dateTo ? moment(dateTo).add(1, 'd').format('YYYY/MM/DD') : undefined
  };
}

const searchQuotationFolio = (params) =>
  Vue.$http.get(`purchase/quotation-requisition/`, { params : paramsTransformer(params)})
    .then(response => {
      return quotationRequisition.fetchCollection(response.data)
    })
    .catch(err => {
      throw err
    })

export default searchQuotationFolio



// WEBPACK FOOTER //
// ./src/services/purchase/quotation/searchQuotation.js